import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14.667 22.667c0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333c0-.734-.6-1.334-1.333-1.334s-1.333.6-1.333 1.334m0-18.667v5.333h2.666v-2.56c4.52.654 8 4.52 8 9.227A9.326 9.326 0 0 1 16 25.333 9.326 9.326 0 0 1 6.667 16c0-2.24.786-4.293 2.106-5.893L16 17.333l1.88-1.88-9.067-9.066v.026C5.893 8.6 4 12.067 4 16c0 6.627 5.36 12 12 12 6.627 0 12-5.373 12-12S22.627 4 16 4zM24 16c0-.733-.6-1.333-1.333-1.333-.734 0-1.334.6-1.334 1.333s.6 1.333 1.334 1.333c.733 0 1.333-.6 1.333-1.333M8 16c0 .733.6 1.333 1.333 1.333.734 0 1.334-.6 1.334-1.333s-.6-1.333-1.334-1.333C8.6 14.667 8 15.267 8 16"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }